import {
  canSaveAsTransferToCommonSubmissions,
  canSaveAsTransferToOwnSubmissions,
  currentSubmissionGroupId,
} from '@selectors/submission';
import { useSelector } from 'react-redux';
import { MgState } from '@types';

export const useSetGroupTemplateId = (groupTemplateId: string, submissionIsCommon: boolean) => {
  const currentGroupId = useSelector(currentSubmissionGroupId);
  const isOpenSaveAsModal = useSelector<MgState, boolean>(
    ({ lettersPage }) => lettersPage.isOpenSaveAsModal
  );
  const hasPermissionTransferToCommonSubmissions = useSelector(
    canSaveAsTransferToCommonSubmissions
  );
  const hasPermissionTransferToOwnSubmissions = useSelector(canSaveAsTransferToOwnSubmissions);

  if (currentGroupId && !groupTemplateId && isOpenSaveAsModal) {
    return true;
  }
  if (submissionIsCommon && !hasPermissionTransferToCommonSubmissions) {
    return true;
  }
  return !submissionIsCommon && !hasPermissionTransferToOwnSubmissions;
};
